import { Card, Typography } from "@mui/material";
import { useMemo } from "react";

type ComponentProps = {
  isTask: boolean;
  data: any;
};

const UserCalled = ({ isTask, data }: ComponentProps) => {
  const filteredData = useMemo(() => {
    return data?.filter((d: any) =>
      ["VIP", "FIFO", "Stock"].includes(d.current_page),
    );
  }, [data]);
  return (
    <Card className="p-4 mb-4">
      <Typography variant="body1" className="font-semibold mb-2">
        User Called
      </Typography>

      {filteredData?.map((d: any, index: number) => (
        <div key={`page-${index}`}>
          <div className="text-base font-semibold">{d.current_page}</div>
          <ul className="py-1 my-1">
            {d.users.map((user: any, userIndex: number) => (
              <li
                key={`user-${userIndex}`}
                className="text-base"
                style={{
                  border: "1px solid #ccc",
                  padding: "4px",
                  marginBottom: "4px",
                  borderRadius: "4px",
                }}
              >
                {user.name}
              </li>
            ))}
          </ul>
          {/* {index + 1 <
            filteredData?.filter((d: any) => d.users?.length > 0)?.length && (
            <hr className="text-secondary-light" />
          )} */}
        </div>
      ))}
    </Card>
  );
};

export default UserCalled;
